import * as React from 'react';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

/*
 * The purpose of this component is strictly to add a side effect of listening to
 * CustomEvents from non-react code telling us to client-navigate.
 *
 * To generate such an event:
 *
 * ```
    var event = new CustomEvent('client-navigate', {
        detail: {
            type: 'replace', // (or 'push')
            to: '/new/path',
        },
    });
    document.dispatchEvent(event);
 * ```
 */
export const NavigationListener = (props: ContextRouter) => {
    React.useEffect(() => {
        // @ts-expect-error
        const navigate: EventListener = (e: CustomEvent) => {
            if (!e.detail.to) return;

            if (e.detail.type === 'replace') {
                props.history.replace(e.detail.to);
            } else if (e.detail.type === 'push') {
                props.history.push(e.detail.to);
            }
        };

        document.addEventListener('client-navigate', navigate, false);

        return () => {
            document.removeEventListener('client-navigate', navigate, false);
        };
    }, [props.history]);

    return null;
};
